document.addEventListener("DOMContentLoaded", () => {
  const redirect_links = document.querySelectorAll('a[data-added-redirect="false"]');
  redirect_links.forEach((link) => {
    link.href += "?redirect=" + encodeURIComponent(window.location.href);
    link.setAttribute("data-added-redirect", "true");
  });
});